<template>
  <div>
    <base-header v-once></base-header>
    name : <input v-model="child.name" placeholder="새창.이름" /><br><br>
    data.id : <input v-model="child.data.id" placeholder="데이터.아이디" /><br><br>
    data.title : <input v-model="child.data.title" placeholder="데이터.제목" /><br><br>
    data.body : <input v-model="child.data.body" placeholder="데이터.본문" /><br><br>

    <button @click="onNewPage()">새창열기(테스트)</button><br><br>
    <button @click="onChange()">변경(테스트)</button><br><br>
    <button @click="onMoveLogin()">로그인_이동</button><br><br>
    <button @click="onSample()">샘플_이동</button><br><br>
    <button @click="logout()">로그아웃</button><br><br>
    <button @click="moveUrl('/orgnz')">조직관리</button><br><br>

  </div>
</template>
<script>
export default {
  name: "Main",
  components: {
  },
  data() {
    return {
      child: this.$store.state.ui.child
    };
  },
  watch: {
    '$store.state.ui.child': function(child, old) {
      console.log('$store.state.ui.child.watch', child, old);
      alert("changed");
      this.child = this.$store.state.ui.child;
    },
    '$store.state.ui.appdb': function()  {
      var key = this.$store.state.ui.appdb.key;
      alert(key);
      var value = this.$store.state.ui.appdb.value;
      alert(value);
    },
  },
  methods: {
    onNewPage: function() {
      this.$utils.nativeIf.outbound.newPage('/sample/detail');
    },
    onChange: function() {
      var child = {
        name: '',
        data: {id:1, title:'', body:''}
      };
      window.app.$root.$store.commit("SET_UI_CHILD", child);
      // this.$store.commit("SET_UI_CHILD", child);
    },
    onMoveLogin: function() {
      this.$router.push({ name: "login" }).catch(function() {});
    },
    onSample: function() {
      this.$utils.nativeIf.outbound.newPage('/sample/');
    },
    moveUrl: function(url) {
      this.$router.push({ path: url }).catch(function() {});
      // this.$utils.nativeIf.outbound.newPage(url);
    },
    logout() {
      console.log("logout");
      this.$store.dispatch("clearUser");
      this.$router.push({ name: "login" }).catch(function() {});
    }
  }
};
</script>
